import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import classNames from "classnames";
import { useFormik } from "formik";
import * as React from "react";
import { roles } from "shared/routes/constant";
import * as yup from "yup";
import styles from "./style.module.scss";
import { block_status } from "shared/utils/constants";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface BlockRequestsProps {
  open: boolean;
  handleClose: () => void;
  handleBlock?: (reason: string) => void;
  selectedItem?: any;
}

interface InitialValuesProps {
  reason: string;
}

export default function BlockRequests({
  open,
  handleClose,
  handleBlock,
  selectedItem,
}: BlockRequestsProps) {
  const initialValues: InitialValuesProps = {
    reason: "",
  };

  const schema = yup.object({
    reason: yup.string().required("Reason is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      handleBlock?.(values?.reason);
      onClose();
    },
  });

  const { handleSubmit, errors } = formik;

  const onClose = () => {
    handleClose();
    formik?.resetForm();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            width: "100%",
            justifyContent: "center",
            maxWidth: (theme) => theme.spacing(80),
            borderRadius: "10px",
          },
        }}
      >
        <DialogContent>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            <div className={styles.headingContainer}>
              <label className={styles.heading}>Reason</label>
              <Icons.CrossIcon
                style={{ cursor: "pointer" }}
                onClick={() => onClose()}
              />
            </div>

            {selectedItem ? (
              !selectedItem?.block_requests?.length ? (
                <div className={styles.noDataCard}>
                  <Icons.NoDataIcon />
                  <h5>No Data Found</h5>
                </div>
              ) : (
                selectedItem?.block_requests?.map((item: any) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label className={styles.label}>
                        ●{" "}
                        {item?.requested_for === block_status.request_block
                          ? "Block "
                          : item?.requested_for === block_status.request_unblock
                          ? "Unblock "
                          : ""}
                        Requested by:{" "}
                        {
                          roles.find(
                            (itm: any) => itm?.role_id === item?.requested_by
                          )?.title
                        }{" "}
                      </label>
                      <textarea
                        className={classNames(styles.textAreaReadOnly)}
                        id="reason"
                        name="reason"
                        value={item?.request_reason}
                        readOnly={true}
                      />
                    </div>
                  );
                })
              )
            ) : (
              <div>
                <textarea
                  className={styles.textarea}
                  id="reason"
                  name="reason"
                  value={formik.values.reason}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {errors.reason && (
                  <div className={styles.errorText}>{formik.errors.reason}</div>
                )}
              </div>
            )}

            {!selectedItem && (
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  className={styles.sendBtn}
                  onClick={() => handleSubmit()}
                >
                  Send
                </button>
                <button className={styles.cancelBtn} onClick={() => onClose()}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
